import React, { useRef } from 'react'
import graphql from 'babel-plugin-relay/macro'
import Page from 'components/Page'
import QueryRender from 'components/QueryRender'
import VehicleIncidentTypeTable from '../components/VehicleIncidentTypeTable'
import { Button } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

const query = graphql`
  query VehicleIncidentTypeIndexQuery {
    viewer {
      ...VehicleIncidentTypeTable_viewer
    }
  }
`

export default function VehicleIncidentTypeIndex() {
  const tableRef = useRef()

  return (
    <Page
      title="Tipos de Incidentes de Vehículos"
      action={
        <Button
          as={Link}
          to="/vehicle-incidents-type/create"
          primary
          icon="plus"
          content="Crear Tipo"
        />
      }
    >
      <QueryRender
        query={query}
        render={({ props }) => props && (
          <VehicleIncidentTypeTable 
            viewer={props.viewer} 
          />
        )}
      />
    </Page>
  )
}